export const firebaseConfig = {
  apiKey: 'AIzaSyAH_Owns7cMrT8pGCLt32chdrdhm6DGte4',
  authDomain: 'filmoteka-project-45131.firebaseapp.com',
  projectId: 'filmoteka-project-45131',
  storageBucket: 'filmoteka-project-45131.appspot.com',
  messagingSenderId: '4911157215',
  appId: '1:4911157215:web:07f069ebba88729a083e6a',
  measurementId: 'G-XQS01LFW6F',
};
